module.exports = __webpack_public_path__ + "img/pin-protect-inaktiv.b491cb7d.svg";